import React from "react";
import { MsalAuthenticationTemplate } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";

import LoadingSpinner from "../LoadingSpinner";
import useDatadogInit from "hooks/useDatadogInit";
import { loginRequest } from "./msalConfig";

const LoginLoading = () => <LoadingSpinner message="Logging you in..." />;

export default function Login(props: React.PropsWithChildren<object>) {
  useDatadogInit();
  return (
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      authenticationRequest={loginRequest}
      loadingComponent={LoginLoading}
    >
      {props.children}
    </MsalAuthenticationTemplate>
  );
}
